var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { pathOr } from 'ramda';
import { muiBankTheme } from '../theme';
var curryGet = function (theme) {
    var getPath = function (path) {
        var getValue = function (value) {
            var parts = path.split('.');
            var pathWithValue = __spreadArray(__spreadArray([], __read(parts), false), [value], false);
            return pathOr('', pathWithValue, theme);
        };
        return getValue;
    };
    return getPath;
};
var composeGetter = function (path) {
    var withValue = function (value) {
        var withTheme = function (_a) {
            var theme = _a.theme;
            return curryGet(theme)(path)(value);
        };
        return withTheme;
    };
    return withValue;
};
var composeMediaGetter = function (key) {
    var withMediaValue = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var withTheme = function (_a) {
            var theme = _a.theme;
            var fn = theme.media[key];
            /**
             * For some reason, with `fn(...args)` TS cannot infer that the correct
             * args are being passed
             */
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        };
        return withTheme;
    };
    return withMediaValue;
};
var mediaGetterFactory = function () {
    var keys = Object.keys(muiBankTheme.media);
    return keys.reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[key] = composeMediaGetter(key), _a)));
    }, {});
};
var gettersFactory = function () {
    var keys = Object.keys(muiBankTheme);
    return keys.reduce(function (acc, key) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = composeGetter(key), _a));
    }, {});
};
var get = __assign(__assign({}, gettersFactory()), { media: mediaGetterFactory() });
export { curryGet };
export default get;
//# sourceMappingURL=getters.js.map